import { inject } from '@angular/core';
import { RedirectFunction, Router } from '@angular/router';
import { StorageService } from '@app/shared';
import { SessionFacade } from '@app/store/session';
import { UPDATE_RELOCK_KEY } from '@app/store/update';
import { filter, map } from 'rxjs';

export const initialize = (): RedirectFunction => {
    return () => {
        const router = inject(Router);
        const sessionFacade = inject(SessionFacade);
        const storageService = inject(StorageService);

        sessionFacade.clear();
        sessionFacade.getSession();

        return sessionFacade.loaded$.pipe(
            filter((loaded) => loaded !== null),
            map((loaded) => {
                if (loaded === true) {
                    return router.createUrlTree(['/', 'mode']);
                }

                storageService.removeItem(UPDATE_RELOCK_KEY);

                return router.createUrlTree(['/', 'auth']);
            }),
        );
    };
};
